import React from 'react';
import { List, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';

export default function BatchView({ visible, onClose, batch, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const mobileLabel = (text) => (
    <div>
      <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>
    </div>
  );
  const child = (text) => {
    if (text == null || text == '') {
      return (
        <div style={{ textAlign: 'center' }}>
          <RedTimes />
        </div>
      );
    }

    return <span style={{ fontSize: isMobile ? '12px' : '15px', fontWeight: 'bold' }}>{t(`${text}`)}</span>;
  };

  const batchFields = [{ label: 'Descrição', value: batch?.description }];

  const batchItemsFields = (batch?.batches_items?.length ? batch.batches_items : [{}]).flatMap((batchItem, i) => [
    { label: `Item ${i + 1} - Tipo de produto`, value: batchItem?.item_name },
    { label: `Item ${i + 1} - Quantidade de entrada`, value: batchItem?.input_amount },
    { label: `Item ${i + 1} - Preço de custo`, value: batchItem?.cost_price },
    { label: `Item ${i + 1} - Vencimento`, value: batchItem?.due_date },
    { label: `Item ${i + 1} - Fornecedor`, value: batchItem?.provider },
  ]);

  const data = [...batchFields, ...batchItemsFields];

  return (
    <Modal
      title={`${t('Informações')} - ${batch?.description ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      {isMobile ? (
        <List
          bordered
          dataSource={data}
          renderItem={({ label, value }) => (
            <List.Item>
              <Typography.Text strong>{mobileLabel(label)}</Typography.Text>
              {child(value)}
            </List.Item>
          )}
        />
      ) : (
        <>
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[{ title: label('Descrição'), dataIndex: 'description', render: child }]}
            dataSource={[batch]}
          />
          <TableView
            pagination={false}
            rowKey={() => 'basic-1'}
            bordered
            columns={[
              {
                title: label('Tipo de produto'),
                dataIndex: 'item_name',
                render: child,
              },
              {
                title: label('Quantidade de entrada'),
                dataIndex: 'input_amount',
                render: child,
              },
              { title: label('Preço de custo'), dataIndex: 'cost_price', render: child },
              { title: label('Vencimento'), dataIndex: 'due_date', render: child },
              { title: label('Fornecedor'), dataIndex: 'provider', render: child },
            ]}
            dataSource={batch?.batches_items}
          />
        </>
      )}
    </Modal>
  );
}
